import { SbefCode } from '@shared/construction/sbef.model';
import { SBEFCustomGroup } from '@shared/construction/sbef-custom-group.model';
import { PropertyChange } from '@shared/helpers/element-property.helpers';
import {
  getSbefGroupByCode,
  SbefResolvedGroupKind,
} from '@shared/helpers/sbef-grouping.helpers';
import { isSbefCode } from '@shared/helpers/sbef.helpers';
import { ElementPropertyName } from '@shared/models/element-property.model';

/**
 * SBEF code a drop on the group row should write, or `undefined` for a group key that
 * maps to no code. Custom groups resolve to their first code.
 */
export const getSbefGroupDropCode = (
  groupKey: string,
  customGroups: SBEFCustomGroup[],
): SbefCode | undefined => {
  const resolvedGroup = getSbefGroupByCode(groupKey, customGroups);
  if (resolvedGroup.kind === SbefResolvedGroupKind.Custom) {
    return resolvedGroup.group.sbefCodes[0];
  }
  return isSbefCode(groupKey) ? groupKey : undefined;
};

/**
 * Property change for a drop on an SBEF group: the group's code becomes the element's own
 * classification. Any inherited `fallbackCount` is dropped — it belongs to the tree position
 * the element was dragged away from, and would resurface once the code is set back to None.
 */
export const getSbefGroupDropPropertyChange = (
  groupSbefCode: SbefCode | undefined,
): PropertyChange => ({
  name: ElementPropertyName.SbefCode,
  count: groupSbefCode ?? '',
  fallbackCount: undefined,
});
